<template>
  <section class="operational-proof" aria-labelledby="operational-proof-title">
    <div class="operational-proof__inner">
      <div class="operational-proof__statement">
        <h2 id="operational-proof-title">Trusted Around the World</h2>
        <p class="operational-proof__stat">500+</p>
        <div class="operational-proof__copy">
          <p class="operational-proof__description">underwater observatories deployed worldwide.</p>
          <p>
            For two decades, we've provided cost-effective underwater monitoring
            solutions for businesses, researchers, and educational organizations worldwide.
          </p>
        </div>
      </div>

      <div class="operational-proof__partners">
        <img
          src="@/assets/images/partners.png"
          alt="Trusted partners"
          loading="lazy"
          decoding="async"
        >
      </div>
    </div>
  </section>
</template>

<script>
export default { name: 'OperationalProof' }
</script>

<style lang="scss">
#app .operational-proof {
  padding: clamp(84px, 7vw, 112px) 0 clamp(72px, 6vw, 94px);
  color: var(--ink);
  background: var(--sand);
}

#app .operational-proof__inner {
  width: min(calc(100% - 80px), 1320px);
  margin: 0 auto;
}

#app .operational-proof__statement {
  display: grid;
  grid-template-columns: minmax(210px, 0.65fr) minmax(210px, 0.55fr) minmax(0, 1fr);
  gap: clamp(38px, 6vw, 88px);
  align-items: center;
}

#app .operational-proof h2 {
  max-width: 8ch;
  margin: 0;
  color: var(--ink);
  font-size: clamp(2.4rem, 3.8vw, 4.1rem);
  line-height: 0.98;
}

#app .operational-proof__stat {
  margin: 0;
  color: var(--brand-blue);
  font-size: clamp(5.3rem, 8vw, 8.4rem);
  font-weight: 500;
  letter-spacing: -0.065em;
  line-height: 0.8;
}

#app .operational-proof__copy {
  padding-left: clamp(28px, 4vw, 64px);
  border-left: 1px solid var(--line-light);
}

#app .operational-proof__description {
  max-width: 440px;
  margin-bottom: 18px;
  color: var(--ink);
  font-size: clamp(1.35rem, 2vw, 1.8rem);
  line-height: 1.24;
}

#app .operational-proof__copy > p:last-child {
  max-width: 610px;
  margin: 0;
  color: var(--copy-dark);
  font-size: 1.08rem;
  line-height: 1.64;
}

#app .operational-proof__partners {
  position: relative;
  display: flex;
  min-height: 176px;
  margin-top: clamp(54px, 6vw, 82px);
  padding: clamp(28px, 3vw, 42px) clamp(24px, 4vw, 58px);
  border-top: 1px solid rgba(11, 40, 81, 0.14);
  border-bottom: 1px solid rgba(11, 40, 81, 0.14);
  overflow: hidden;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.34);
}

#app .operational-proof__partners img {
  display: block;
  width: min(92%, 1040px);
  max-height: 154px;
  object-fit: contain;
  opacity: 0.7;
  filter: grayscale(1) contrast(1.12);
  transform: scale(1.42);
}

@media (max-width: 900px) {
  #app .operational-proof__statement {
    grid-template-columns: 1fr 1fr;
  }
  #app .operational-proof__copy {
    padding: 36px 0 0;
    border-top: 1px solid var(--line-light);
    border-left: 0;
    grid-column: 1 / -1;
  }
}

@media (max-width: 560px) {
  #app .operational-proof { padding: 78px 0; }
  #app .operational-proof__inner {
    width: calc(100% - 40px);
  }
  #app .operational-proof__statement { display: block; }
  #app .operational-proof h2 { margin-bottom: 48px; }
  #app .operational-proof__stat { margin-bottom: 36px; }
  #app .operational-proof__partners {
    min-height: 150px;
    margin-top: 58px;
    padding: 28px 8px;
  }
  #app .operational-proof__partners img {
    width: 112%;
    max-width: none;
    transform: scale(1.12);
  }
}
</style>
